import { render, staticRenderFns } from "./class.vue?vue&type=template&id=60ce8ace&scoped=true&"
import script from "./class.vue?vue&type=script&lang=js&"
export * from "./class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce8ace",
  null
  
)

export default component.exports